<script lang="ts">
  import {replaceValues, t} from '../i18n'
  import type {Notification} from '../types'
  import {formatDateTimeRelative} from '../utils/format'

  export let notificationParams: { views_count: number }
  export let notification: Notification
</script>

<div class="item">
  <span class="notice-img with-icon">
    <i class="icon-p-feather"/>
  </span>

  <div class="notice-content">
    <span class="notice-action db">
      {replaceValues(t.timelines.views_achievement, {n: notificationParams.views_count})}
    </span>
    <i class="notice-time db">{formatDateTimeRelative(notification.created_at)}</i>
  </div>
</div>
